<div class="flex justify-center my-4" *ngIf="loading">
  <p-progressSpinner></p-progressSpinner>
</div>
